import React, { useState, useEffect } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import ApiBasketLog from "../../../../../../core/api/api.basketLog";
import CloseIcon from "@mui/icons-material/CloseRounded";
function ViewHistoryOrderPerson(props) {
  const [show, setShow] = useState(true);
  const [logList, setlogList] = useState([]);

  const handleClose = () => {
    setShow(!show);
    props.callBack();
  };

  useEffect(() => {
    (async () => {
      const response = await ApiBasketLog.getBasketLog({
        BasketId: props.basketId,
        BasketItemId: "",
        BasketPersonId: "",
        PageSize: 100,
      });
      if (response.succeeded == true) {
        setlogList(response.data);
      }
    })();
    return () => { };
  }, []);

  return (
    <Modal size="xl" onHide={handleClose} show={show}>
      <Modal.Header closeButton>
        <Modal.Title>تاریخچه تغییرات </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped hover responsive="md" bordered={false} borderless={false}>
          <thead className="border">
            <tr className="border">
              <th className="bg-light-primary ">
                <small className="text-center text-muted"></small>
              </th>
              <th className="bg-light-primary ">
                <small className="text-center text-muted">نوع فعالیت</small>{" "}
              </th>
              <th className="bg-light-primary ">
                <small className="text-center text-muted">مقدار</small>
              </th>
              <th className="bg-light-primary ">
                <small className="text-center text-muted">توسط</small>
              </th>
              <th className="bg-light-primary ">
                <small className="text-center text-muted">توضیحات</small>
              </th>
              <th className="bg-light-primary  ">
                <small className="text-center text-muted">تاریخ</small>
              </th>
              <th className="bg-light-primary ">
                <small className="text-center text-muted">شماره بلیط</small>
              </th>
              <th className="bg-light-primary ">
                <small className="text-center text-muted">تفریح</small>
              </th>
              <th className="bg-light-primary ">
                <small className="text-center text-muted">تاریخ انجام</small>
              </th>
            </tr>
          </thead>
          <tbody>
            {logList.map((item, index) => (
              <tr key={index}>
                <td>
                  <small>{index + 1}</small>
                </td>
                <td>
                  <small>{item.logTypeS}</small>
                </td>
                <td>
                  <small>{item.value}</small>
                </td>
                <td>
                  <small>{item.createdByFullName}</small>
                </td>
                <td>
                  <small>{item.description}</small>
                </td>
                <td>
                  {" "}
                  <small>{item.createdPersianTime}</small>
                </td>
                <td>
                  <small>{item.basketItemPersonId}</small>{" "}
                </td>
                <td>
                  <small>{item.basketItemAmusementServiceName}</small>{" "}
                </td>
                <td>
                  <small>{item.basketItemCheckInDate}</small>{" "}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          <CloseIcon className="mr-1" />
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ViewHistoryOrderPerson;
